import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Sociallinks.css";

const SocialLinks = () => {
  const [links, setLinks] = useState({
    facebook: "",
    instagram: "",
    twitter: "",
    youtube: "",
    linkedin: "",
    pinterest: "",
    snapchat: "",
    telegram: "",
    whatsapp: "",
    tiktok: "",
    reddit: "",
  });

  const ensureProtocol = (url) => {
    if (!url) return "";
    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };

  const fetchData = async () => {
    try {
      const { data } = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Sociallinks"
      );

      const updated = { ...links };

      data.forEach((item) => {
        const key = item.title?.toLowerCase();
        if (updated.hasOwnProperty(key)) {
          updated[key] = ensureProtocol(item.url);
        }
      });

      setLinks(updated);
    } catch (err) {
      console.error("Error fetching social links:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const platforms = [
    { key: "facebook", icon: "fab fa-facebook-f" },
    { key: "instagram", icon: "fab fa-instagram" },
    { key: "twitter", icon: "fab fa-twitter" },
    { key: "youtube", icon: "fab fa-youtube" },
    { key: "linkedin", icon: "fab fa-linkedin-in" },
    { key: "pinterest", icon: "fab fa-pinterest-p" },
    { key: "snapchat", icon: "fab fa-snapchat-ghost" },
    { key: "telegram", icon: "fab fa-telegram-plane" },
    { key: "whatsapp", icon: "fab fa-whatsapp" },
    { key: "tiktok", icon: "fab fa-tiktok" },
    { key: "reddit", icon: "fab fa-reddit-alien" },
  ];

  return (
    <div className="social-links-box container my-3 py-2">
      <div className="d-flex flex-wrap justify-content-center">
        <h3 className="col-12 text-center social-links-title">Follow Us</h3>

        <div className="col-12 d-flex flex-wrap justify-content-center gap-3">
          {platforms.map(({ key, icon }) =>
            links[key] ? (
              <a
                key={key}
                href={links[key]}
                target="_blank"
                rel="noopener noreferrer"
                className={`social-icon ${key}`}
              >
                <i className={icon}></i>
              </a>
            ) : null
          )}
        </div>
      </div>
    </div>
  );
};

export default SocialLinks;
